import React, { useRef } from 'react';

const BindingPopup = ({ popup, onBind, onUnbind, onClose }) => {
    const inputRef = useRef(null);

    if (!popup) return null;
    const { x, y, existingKey } = popup;

    const handleConfirm = () => {
        if (inputRef.current) {
            onBind(inputRef.current.value);
        }
    };

    return (
        <div 
            className="fixed z-[100] bg-white border border-slate-300 shadow-xl rounded p-3 flex flex-col gap-2 w-52"
            style={{ left: x, top: y }}
            onClick={(e) => e.stopPropagation()}
        >
            <div className="text-[10px] font-bold text-gray-500 uppercase">{existingKey ? 'Edit Binding' : 'New Binding'}</div>
            <input 
                autoFocus 
                defaultValue={existingKey || ''} 
                className="border text-xs p-1 rounded w-full" 
                placeholder="Exported Key Name"
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        onBind(e.target.value);
                    }
                }}
                ref={inputRef}
            />
            <div className="flex gap-2 justify-end">
                {existingKey && (
                    <button 
                        className="text-xs text-red-500 hover:underline" 
                        onClick={() => onUnbind()}
                    >
                        Unbind
                    </button>
                )}
                <button 
                    className="text-xs bg-blue-500 text-white px-2 py-1 rounded" 
                    onClick={handleConfirm}
                >
                    {existingKey ? 'Update' : 'Bind'}
                </button>
                <button 
                    className="text-xs text-gray-400" 
                    onClick={onClose}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
};

export default BindingPopup;
